import {handleFileSend, handleSend} from '../handleSend'

export const PaymentApi = {
  //
  //   * *
  //
  // 查询缴费项目接口（48,0000）
  queryPaymentProject (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '48', '0000', '0', 'message')
  },
  // 新增/修改缴费项目接口（48,0001）
  handlePayment (data, type = 0) {
    return handleSend(data, '48', '0001', String(type), 'message')
  },
  // 查询/导出缴费明细接口
  queryOrExportPaymentRecord (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '48', '0002', String(type), 'message')
  },
  // 查询/导出缴费统计接口
  queryOrExportPaymentStatic (data, type = 0) {
    return handleSend(data, '48', '0003', String(type), 'message')
  },
  // 缴费项目发布/撤销接口
  useOrDelPayment (data, type = 0) {
    return handleSend(data, '48', '0004', String(type), 'message')
  },
  // 删除缴费项目接口
  delPaymentProject (data) {
    return handleSend(data, '48', '0005')
  },
  // 查询缴费参数（48,0006
  queryPaymentParam (data = {}) {
    return handleSend(data, '48', '0006', '0', 'message')
  },
  // 删除缴费项目接口(48,0007
  revokePaymentRecord (data) {
    return handleSend(data, '48', '0007')
  },
  // 查询缴费人员统计接口(48,0008
  queryPaymentCount (data) {
    return handleSend(data, '48', '0008', '0', 'message')
  },
  // 查询缴费日对帐报表接口（48,0009
  queryPaymentDayReport (data, type = 0) {
    return handleSend(data, '48', '0009', String(type), 'message')
  },
  // 新增/修改缴费范围接口（48,1001
  handlePaymentArea (data, type = 0) {
    return handleSend(data, '48', '1001', String(type), 'message')
  },
  // 查询缴费范围接口（48,1002
  queryPaymentArea (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '48', '1002', String(type), 'message')
  },
  // 缴费范围删除接口（48,1003
  delPaymentArea (data, type = 0) {
    return handleSend(data, '48', '1003', String(type), 'message')
  },
  // 新增/修改减免设置接口（48,2001
  handlePaymentDiscount (data, type = 0) {
    return handleSend(data, '48', '2001', String(type), 'message')
  },
  // 查询减免设置接口（48,2002）
  queryPaymentDiscount (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '48', '2002', String(type), 'message')
  },
  // 减免设置删除接口（48,2003
  delPaymentDiscount (data, type = 0) {
    return handleSend(data, '48', '2003', String(type), 'message')
  },
  // 查询已设置的缴费人员部门接口（48,2004
  queryAreaDeptList (data) {
    return handleSend(data, '48', '2004', '0', 'message')
  },
  // 查询设置的缴费人员接口（48,2005
  queryAreaPersonList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '48', '2005', '0', 'message')
  },
  // 设置开放消费天数接口（48,3001
  handleOpenConsumeDays (data) {
    return handleSend(data, '48', '3001')
  },
  // 查询未缴费锁定明细接口（48,3002
  queryLimitedConsume (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '48', '3002', String(type), 'message')
  },
  // 缴费人员导入接口（48,4001
  batchCreatePaymentPerson (data, id) {
    let fd = new FormData() // FormData 对象
    fd.append('file', data) // 文件对象
    fd.append('fileType', '0')
    fd.append('content', id)
    fd.append('AppCode', '48')
    fd.append('BizCode', '4001')
    return handleFileSend('/uploadFiles', '48', '4001', fd, 'Alert')
  },
  // 查询导入缴费人员列表接口（48,4002
  queryPaymentPerson (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '48', '4002', String(type), 'message')
  },
  // 缴费人员新增/修改接口（48,4003
  handlePaymentPerson (data, type = 0) {
    return handleSend(data, '48', '4003', String(type), 'message')
  },
  // 缴费人员删除接口（48,4004
  delPaymentPerson (data) {
    return handleSend(data, '48', '4004')
  }
}



// WEBPACK FOOTER //
// ./src/request/Payment/payment_api.js